import React from "react";
import CardClass from "../../../CardClass";
import EmptyState from "../../../EmptyState";
import MUIButton from "@mui/material/Button";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import MUISwitch from "@mui/material/Switch";
import MUIIconButton from "@mui/material/IconButton";
import MUIAddIcon from "@mui/icons-material/Add";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUIGrid from "@mui/material/Grid";
import DialogSearchOrderActivityType from "../../../Dialog/Search/DialogSearchOrderActivityType";
import TileOrderActivityType from "../../../Tile/TileOrderActivityType";
import PropTypes from "prop-types";
import OrderActivityType from "../../../../Utility/Crud/OrderActivityType";
import MainContext from "../../../../Context/MainContext/MainContext";

export default class CardAdminQueueFilterOrderActivityOrderType extends CardClass {
  static contextType = MainContext; // For legacy class components

  constructor(props) {
    super(props);

    this.state.orderActivityTypeDialogOpen = false;
  }

  /**
   * Render the content of the card.
   */
  renderContent() {
    const handleRemove = (orderType) => {
      const filter = this.props.queue.filter;
      if (!filter["order_activity.order_type"]?.properties?.value) {
        return;
      }
      filter["order_activity.order_type"].properties.value = filter[
        "order_activity.order_type"
      ].properties.value.filter((entry) => entry !== orderType);
      if (filter["order_activity.order_type"].properties.value.length === 0) {
        delete filter["order_activity.order_type"];
      }

      this.props.onChange({
        filter: filter,
      });
    };

    const values =
      this.props.queue?.filter?.["order_activity.order_type"]?.properties
        ?.value || [];

    const excludeChecked =
      this.props.queue?.filter?.["order_activity.order_type"]?.properties
        ?.operator === "not in";

    const handleExcludeToggle = (event) => {
      const filter = this.props.queue.filter;
      filter["order_activity.order_type"].properties.operator = event.target
        .checked
        ? "not in"
        : "in";

      this.props.onChange({
        filter: filter,
      });
    };

    if (values.length > 0) {
      return (
        <>
          <MUIFormControlLabel
            sx={{ marginLeft: 0 }}
            control={
              <MUISwitch
                color="error"
                checked={excludeChecked}
                onChange={handleExcludeToggle}
              />
            }
            label="Exclude"
          />
          <MUIGrid container spacing={2}>
            {values.map((orderActivityTypeName) => {
              const orderActivityType = OrderActivityType.read(
                this.context.orderActivityTypesIndexed,
                [
                  {
                    key: "name",
                    value: orderActivityTypeName,
                  },
                ],
              )[0];
              return (
                <MUIGrid key={orderActivityTypeName} item xs={12} sm={6} md={4}>
                  <TileOrderActivityType
                    orderActivityType={orderActivityType}
                    iconButtons={[
                      <MUIIconButton
                        onClick={() => handleRemove(orderActivityTypeName)}
                      >
                        <MUIDeleteIcon />
                      </MUIIconButton>,
                    ]}
                  />
                </MUIGrid>
              );
            })}
            {this.renderDialog()}
          </MUIGrid>
        </>
      );
    } else {
      return (
        <>
          <EmptyState line1="Not Configured" line2="Showing all Order Types" />
          {this.renderDialog()}
        </>
      );
    }
  }

  /**
   * Renders a search dialog of Order Types
   */
  renderDialog() {
    const handleAdd = (orderType) => {
      const filter = (this.props.queue && this.props.queue.filter) || {};
      if (!filter["order_activity.order_type"]) {
        filter["order_activity.order_type"] = {
          type: "set",
          properties: {
            operator: "in",
            value: [],
          },
        };
      }
      filter["order_activity.order_type"].properties.value = [
        ...new Set([
          ...(filter["order_activity.order_type"].properties.value || []),
          orderType.name,
        ]),
      ];

      this.props.onChange({
        filter: filter,
      });
    };

    return (
      <DialogSearchOrderActivityType
        open={this.state.orderActivityTypeDialogOpen}
        onClose={() => this.setState({ orderActivityTypeDialogOpen: false })}
        onSelect={handleAdd}
      />
    );
  }

  /**
   * Renders add Order Type button
   */
  getActions() {
    const handleAdd = () => {
      this.setState({
        orderActivityTypeDialogOpen: true,
      });
    };

    const buttonItems = [
      <MUIButton
        component="label"
        variant="outlined"
        startIcon={<MUIAddIcon />}
        onClick={handleAdd}
      >
        Add Order Type
      </MUIButton>,
    ];

    return buttonItems;
  }

  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "Filter: Order Activity > Order Type";
  }
}
